<script context="module">
    const modalPaddingPx = 50;
    export {modalPaddingPx};
</script>

<script>
    import {fly, fade} from 'svelte/transition';

    export let handleModalClose;
    export let selectedTag;
    export let orgLogoUrl;
    export let orgName;
    export let orgContactEmail;

    let modalNode;
    function handleContainerClick(event) {
        let isClickInsideModal =
            modalNode.contains(event.target) && modalNode != event.target;
        if (!isClickInsideModal) {
            handleModalClose();
        }
    }
    function handleEscape(event) {
        if (event.keyCode == 27) {
            handleModalClose();
        }
    }
</script>

<svelte:window on:keydown={handleEscape} />

<div
    class="modal-container"
    on:click={handleContainerClick}
    style="padding:{modalPaddingPx}px;"
>
    <div class="modal-backdrop" transition:fade={{duration: 200}} />
    <div class="modal-close">
        <ion-icon name="close-outline" />
        <span class="keyboard-shortcut"> esc </span>
    </div>
    <div
        class="modal"
        bind:this={modalNode}
        transition:fly={{y: 100, duration: 200}}
    >
        <slot />
        <div class="sidebar-content">
            {#if orgLogoUrl}<div
                    style="padding: 0 20px; /* To prevent the logo from being too wide */"
                >
                    <address
                        class="org-logo"
                        style="background-image:url({orgLogoUrl});"
                    ></address>
                </div>
            {:else if orgName}
                <h1 class="brand-name">{orgName}</h1>
            {/if}
            {#if selectedTag == 'Privacy Policy'}
                <h1>Privacy Policy</h1>
                <p>
                    <strong>Information Collection: </strong>We collect mobile
                    numbers and emails from clients who opt-in for
                    communication. We also collect basic personal information
                    for service provision.
                </p>
                <p>
                    <strong>Use of Information: </strong>Mobile numbers are used
                    for text messages related to our programs and offers. Emails
                    are used for updates and promotional content.
                </p>
                <p>
                    <strong>Third-Party Services: </strong>We may use
                    third-party services for website functionality and
                    analytics, which collect data per their policies.
                </p>
                <p>
                    <strong>Data Retention: </strong>We retain personal
                    information as long as necessary for the fulfillment of our
                    services.
                </p>

                <p>
                    <strong>Your Rights: </strong>You have the right to access,
                    correct, or delete your personal information. Contact us for
                    such requests.
                </p>
                <p>
                    <strong>Data Security: </strong>We protect personal
                    information with reasonable security measures against loss
                    and unauthorized access.
                </p>
                <p>
                    <strong>Opt-Out Policy: </strong>You may opt-out of
                    receiving text messages or emails at any time. Instructions
                    for opting out are included in every communication.
                </p>
                <p>
                    <strong>Changes to Privacy Policy: </strong>We reserve the
                    right to update this privacy policy at any time. Changes
                    will be posted on our website.
                </p>
                <p>
                    <strong>Contact Us: </strong>For questions regarding this
                    policy, please contact us at
                    <a href="mailto:{orgContactEmail}" title={orgContactEmail}
                        >Email us</a
                    >.
                </p>
            {:else if selectedTag == 'Terms of Service'}<h1>
                    Terms of Service
                </h1>
                <p>
                    <strong>Acceptance of Terms: </strong>By accessing this
                    website, you agree to be bound by these Terms and Conditions
                    of Use, all applicable laws and regulations. If you do not
                    agree, you are prohibited from using or accessing this site.
                </p>
                <p>
                    <strong>Prohibited Activities: </strong>Users are prohibited
                    from unauthorized activities including modifying or copying
                    materials, using the materials for commercial purposes,
                    decompiling software, and transferring materials to another
                    server.
                </p>
                <p>
                    <strong>Disclaimer: </strong>The materials on our website
                    are provided “as is”. We disclaim all warranties, express or
                    implied, regarding the accuracy and reliability of these
                    materials.
                </p>
                <p>
                    <strong>Limitation of Liability: </strong>We are not liable
                    for any damages arising from the use or inability to use the
                    materials on our website, including data loss or business
                    interruption.
                </p>
                <p>
                    <strong>Revisions and Errata: </strong>The materials on our
                    website may include errors. We do not guarantee the accuracy
                    of these materials and may change them at any time without
                    notice.
                </p>
                <p>
                    <strong>Governing Law: </strong>Any claim related to the
                    website shall be governed by the laws of the State without
                    regard to its conflict of law provisions.
                </p>
                <p>
                    <strong>Modifications to Terms: </strong>We may revise these
                    terms at any time without notice. By using this website, you
                    agree to the current version of these Terms and Conditions
                    of Use.
                </p>
            {/if}
        </div>
    </div>
</div>

<style>
    .modal-container {
        /* overscroll-behavior: contain; */
        background: rgba(0, 0, 0, 0.01); /* fix scrollbar contrast */
        position: absolute;
        overflow: auto;
        --webkit-overflow-scrolling: touch;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        /* padding: 80px; */
    }
    .modal-backdrop {
        background: var(--offblack-backdrop);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    @supports (backdrop-filter: blur(20px)) {
        .modal-backdrop {
            background: var(--offblack-backdrop-blur);
            backdrop-filter: blur(20px);
            backdrop-filter: saturate(180%) blur(20px);
        }
    }
    .modal-close {
        color: white;
        position: fixed;
        top: 0;
        right: 0;
        width: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
    }
    .modal-close ion-icon {
        font-size: 48px;
        padding-top: 2px;
    }
    .modal-close .keyboard-shortcut {
        /* border: 1px solid; */
        border-radius: 3px;
        font-size: 12px;
        /* font-family: monospace; */
        font-weight: 400;
        line-height: 14px;
        padding: 0 4px 1px;
        margin-top: -8px;
        opacity: 0.62;
    }
    .modal {
        width: 60%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 80%;
    }
    .modal > :global(*) {
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
    }
    .sidebar-content {
        /* flex-grow: 1; */
        height: 100%;
        /* flex-shrink: 1; */
        display: flex;
        flex-direction: column;
        align-items: stretch;
        background: #ffffff;
        color: var(--offblack);
        border-radius: 4px;
        padding: 30px;
        overflow: auto;
        color: #000000;
    }
    strong {
        font-weight: 800;
    }
    .org-logo {
        height: 160px;
        margin-bottom: 20px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-size: contain;
    }
    .brand-name {
        font-size: 48px;
        font-weight: 900;
        display: flex;
        justify-content: center;
        margin: 20px;
    }
</style>
